import { render, staticRenderFns } from "./DeviceGroupDialog.vue?vue&type=template&id=08a7dd50"
import script from "./DeviceGroupDialog.vue?vue&type=script&lang=js"
export * from "./DeviceGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports